import { Component, Fragment } from "react";
import PropTypes from "prop-types";
import TodoItem from "apps/todo/components/todo-item";
import _ from "underscore";
import moment from "moment";
import TodoForm from "apps/todo/components/todo-form";
import { IconButton } from "@evertrue/et-components";
import ReminderDataContainer from "apps/todo/components/reminder-data-container";

const getFromDate = date => {
  return moment(date)
    .startOf("day")
    .valueOf();
};

class TodoList extends Component {
  state = {
    show_completed: false,
    selected_id: null,
    edit_id: null,
    showTodoForm: false,
  };

  static propTypes = {
    todos: PropTypes.array,
    toDoCheckmarkTappedWithId: PropTypes.func,
    placeholder: PropTypes.string,
    deleteTodo: PropTypes.func,
    updateTodo: PropTypes.func,
    createTodo: PropTypes.func,
    currentDate: PropTypes.number,
    listHeader: PropTypes.element.isRequired,
  };

  static defaultProps = {
    todos: [],
    toDoCheckmarkTappedWithId: () => {},
    placeholder: "No Data",
    deleteTodo: () => {},
    updateTodo: () => {},
    createTodo: () => {},
    currentDate: 0,
  };

  toggleShowCompleted = () => {
    this.setState({
      show_completed: !this.state.show_completed,
    });
  };

  selectedTodo = id => {
    this.setState(state => {
      return { selected_id: state.selected_id === id ? null : id };
    });
  };

  editButtonClickedFor = id => {
    this.setState({
      edit_id: id,
    });
  };

  clearEditForm = () => {
    this.setState({
      edit_id: null,
    });
  };

  addFormStatus = status => {
    this.setState({
      showTodoForm: status,
    });
  };

  postTodo = todo => {
    this.addFormStatus(false);
    return this.props.createTodo(todo);
  };

  editTodo = (todo, reminder) => {
    this.clearEditForm();
    return this.props.updateTodo(todo);
  };

  render() {
    const [completed, inComplete] = _.partition(this.props.todos, todo => todo.completed);
    const todo_obj = {
      due_date: getFromDate(this.props.currentDate),
      summary: "",
      description: "",
    };
    return (
      <Fragment>
        {this.state.showTodoForm && (
          <ReminderDataContainer
            render={({ reminders, createReminder, deleteReminder, fetchReminder, editReminder }) => {
              return (
                <TodoForm
                  todo={todo_obj}
                  clearForm={() => this.addFormStatus(false)}
                  createTodo={this.postTodo}
                  createReminder={createReminder}
                  deleteReminder={deleteReminder}
                  editReminder={editReminder}
                />
              );
            }}
          />
        )}
        <div className="todo--section-header">
          {this.props.listHeader}
          {!this.state.showTodoForm && (
            <IconButton title="Add New To do" icon="add-circle" onClick={() => this.addFormStatus(true)} />
          )}
        </div>
        <div className="todo-list--wrapping-div">
          <ul className="todo-list--section">
            {inComplete.map(toDo => {
              return (
                <ReminderDataContainer
                  key={toDo.id}
                  render={({ reminders, createReminder, deleteReminder, fetchReminder, editReminder }) => {
                    return (
                      <TodoItem
                        key={toDo.id}
                        todo={toDo}
                        editMode={this.state.edit_id === toDo.id ? true : false}
                        onClickListner={this.props.toDoCheckmarkTappedWithId}
                        showInfo={this.state.selected_id === toDo.id ? true : false}
                        toggleDropdown={this.selectedTodo}
                        deleteTodo={this.props.deleteTodo}
                        editButtonClicked={this.editButtonClickedFor}
                        clearForm={this.clearEditForm}
                        updateTodo={this.editTodo}
                        fetchReminder={fetchReminder}
                        reminders={reminders}
                        createReminder={createReminder}
                        deleteReminder={deleteReminder}
                        editReminder={editReminder}
                        icon="todolistcircle"
                      />
                    );
                  }}
                />
              );
            })}
            {inComplete.length <= 0 && <li className="todo-list--message">{this.props.placeholder}</li>}
          </ul>
          {completed.length > 0 &&
            (this.state.show_completed ? (
              <span role="button" tabIndex={0} className="todo-list--text-button" onClick={this.toggleShowCompleted}>
                HIDE COMPLETED
              </span>
            ) : (
              <span role="button" tabIndex={0} className="todo-list--text-button" onClick={this.toggleShowCompleted}>
                SHOW COMPLETED ({completed.length})
              </span>
            ))}
          {this.state.show_completed && (
            <ul className="todo-list--section">
              {completed.map(toDo => {
                return (
                  <ReminderDataContainer
                    key={toDo.id}
                    render={({ reminders, createReminder, deleteReminder, fetchReminder, editReminder }) => {
                      return (
                        <TodoItem
                          key={toDo.id}
                          todo={toDo}
                          editMode={this.state.edit_id === toDo.id ? true : false}
                          extraClass="todo-list--completed-cell"
                          onClickListner={this.props.toDoCheckmarkTappedWithId}
                          showInfo={this.state.selected_id === toDo.id ? true : false}
                          toggleDropdown={this.selectedTodo}
                          deleteTodo={this.props.deleteTodo}
                          editButtonClicked={this.editButtonClickedFor}
                          clearForm={this.clearEditForm}
                          updateTodo={this.editTodo}
                          fetchReminder={fetchReminder}
                          reminders={reminders}
                          deleteReminder={deleteReminder}
                          createReminder={createReminder}
                          editReminder={editReminder}
                          icon="check-circle"
                        />
                      );
                    }}
                  />
                );
              })}
            </ul>
          )}
        </div>
      </Fragment>
    );
  }
}

export default TodoList;
